/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Private Data Enclave API
 * OpenAPI spec version: 0.1.0
 */
import {faker} from '@faker-js/faker';

import type {RequestHandlerOptions} from 'msw';
import {HttpResponse, http} from 'msw';

import type {OrganizationListResponse, OrganizationResponse} from '../../models';

export const getGetOrganizationsResponseMock = (
  overrideResponse: Partial<Extract<OrganizationListResponse, object>> = {},
): OrganizationListResponse => ({
  organizations: Array.from({length: faker.number.int({min: 1, max: 10})}, (_, i) => i + 1).map(() => ({
    data_enclave_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
    email_domains: Array.from({length: faker.number.int({min: 1, max: 10})}, (_, i) => i + 1).map(() =>
      faker.string.alpha({length: {min: 10, max: 20}}),
    ),
    full_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
    id: faker.string.uuid(),
    name: faker.helpers.fromRegExp('^[A-Za-z0-9]+(?:[-_][A-Za-z0-9]+)*$'),
    partner: faker.datatype.boolean(),
  })),
  ...overrideResponse,
});

export const getGetOrganizationResponseMock = (
  overrideResponse: Partial<Extract<OrganizationResponse, object>> = {},
): OrganizationResponse => ({
  data_enclave_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
  email_domains: Array.from({length: faker.number.int({min: 1, max: 10})}, (_, i) => i + 1).map(() =>
    faker.string.alpha({length: {min: 10, max: 20}}),
  ),
  full_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
  id: faker.string.uuid(),
  name: faker.helpers.fromRegExp('^[A-Za-z0-9]+(?:[-_][A-Za-z0-9]+)*$'),
  partner: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getGetOrganizationsMockHandler = (
  overrideResponse?:
    | OrganizationListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<OrganizationListResponse> | OrganizationListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/organizations',
    async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
      return HttpResponse.json(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetOrganizationsResponseMock(),
        {status: 200},
      );
    },
    options,
  );
};

export const getCreateOrganizationsMockHandler = (
  overrideResponse?:
    | unknown
    | void
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<unknown | void> | unknown | void),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/organizations',
    async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }

      return new HttpResponse(null, {status: 200});
    },
    options,
  );
};

export const getGetOrganizationMockHandler = (
  overrideResponse?:
    | OrganizationResponse
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<OrganizationResponse> | OrganizationResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/organizations/:organizationName',
    async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
      return HttpResponse.json(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetOrganizationResponseMock(),
        {status: 200},
      );
    },
    options,
  );
};

export const getPatchOrganizationMockHandler = (
  overrideResponse?:
    | unknown
    | void
    | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<unknown | void> | unknown | void),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/organizations/:organizationName',
    async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }

      return new HttpResponse(null, {status: 200});
    },
    options,
  );
};

export const getUpdateOrganizationMockHandler = (
  overrideResponse?:
    | unknown
    | void
    | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<unknown | void> | unknown | void),
  options?: RequestHandlerOptions,
) => {
  return http.put(
    '*/organizations/:organizationName',
    async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }

      return new HttpResponse(null, {status: 200});
    },
    options,
  );
};
export const getOrganizationsMock = () => [
  getGetOrganizationsMockHandler(),
  getCreateOrganizationsMockHandler(),
  getGetOrganizationMockHandler(),
  getPatchOrganizationMockHandler(),
  getUpdateOrganizationMockHandler(),
];
